module.exports = __webpack_public_path__ + "img/1.2c0a8bc8.png";